import { cloneDeep } from "lodash";

import { type TableColumnWidthInfo } from "@devexpress/dx-react-grid";

import { type TableState } from "../hooks/use-table-state";
import {
  FIXED_NAME_COLUMN_DEFAULT_WIDTH,
  FIXED_NAME_COLUMN_ID,
  FIXED_STATUS_COLUMN_DEFAULT_WIDTH,
  FIXED_STATUS_COLUMN_ID,
} from "../table/components/constants";
import { type TabId } from "../tabs";
import { type TopLevelBreakdown } from "../types";

export const getColumnWidths = (tableState: TableState) => [
  {
    columnName: FIXED_NAME_COLUMN_ID,
    width:
      tableState.fixedColumnWidths[FIXED_NAME_COLUMN_ID] ||
      FIXED_NAME_COLUMN_DEFAULT_WIDTH,
  },
  {
    columnName: FIXED_STATUS_COLUMN_ID,
    width:
      tableState.fixedColumnWidths[FIXED_STATUS_COLUMN_ID] ||
      FIXED_STATUS_COLUMN_DEFAULT_WIDTH,
  },
  ...tableState.columnConfigs.map(({ id, width }) => ({
    columnName: id,
    width: width,
  })),
];

export const updateColumnConfigWidth =
  (columnWidths: TableColumnWidthInfo[]) =>
  (tableState: TableState): TableState => {
    const tableStateCopy = cloneDeep(tableState);
    const columnWidthMap = new Map(
      columnWidths.map(({ columnName, width }) => [columnName, width]),
    );
    const nameColumnWidth =
      columnWidthMap.get(FIXED_NAME_COLUMN_ID) ||
      FIXED_NAME_COLUMN_DEFAULT_WIDTH;
    const statusColumnWidth =
      columnWidthMap.get(FIXED_STATUS_COLUMN_ID) ||
      FIXED_STATUS_COLUMN_DEFAULT_WIDTH;

    const newColumnConfigs = tableStateCopy.columnConfigs.map(
      (columnConfig) => {
        const width = columnWidthMap.get(columnConfig.id);
        if (width) {
          return { ...columnConfig, width };
        }
        return columnConfig;
      },
    );

    return {
      ...tableStateCopy,
      fixedColumnWidths: {
        [FIXED_NAME_COLUMN_ID]: nameColumnWidth,
        [FIXED_STATUS_COLUMN_ID]: statusColumnWidth,
      },
      columnConfigs: newColumnConfigs,
    };
  };

export const checkShouldDrawIconsInTable = ({
  breakdowns,
  activeTab,
}: {
  breakdowns: TopLevelBreakdown[];
  activeTab: TabId;
}) => {
  const isPlatformFirstBreakdown =
    breakdowns?.[0]?.key === "Platform (Northbeam)";
  const isBreakdownTab = activeTab === "breakdown";
  const hasNoBreakdowns = breakdowns?.length === 0;
  return isPlatformFirstBreakdown || (isBreakdownTab && hasNoBreakdowns);
};
